import { MapPin, ShieldCheck, Users, Zap } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
export default function YourTeamOnTheGroundInChina() {
  const advantages = [{
    icon: <ShieldCheck className="size-5 text-primary" />,
    title: "Operation, Design Construction or GISTM Compliance",
    description: "Rigorous oversight ensuring your facilities meet the highest international safety and environmental standards."
  }, {
    icon: <Zap className="size-5 text-primary" />,
    title: "Water Management, Reduction or Optimization",
    description: "Specialized programs focused on water balance optimization and significant reduction in impoundment footprints."
  }, {
    icon: <Users className="size-5 text-primary" />,
    title: "EOR, IRTB, Peer Review & Technical Support",
    description: "Providing dedicated Engineer of Record services and direct technical leadership for geotechnical stability."
  }];
  return <section data-section-id="155005" id="global-support-network" className="dark bg-background text-foreground relative w-full overflow-hidden py-24 lg:py-32">
      {}
      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1618705/img/dark_monochrome_world_map_bg.png" alt="Global map indicating AGT Engineering support sites" className="h-full w-full object-cover opacity-30 grayscale" />
        {}
        <div className="absolute inset-0 bg-gradient-to-r from-background via-background/90 to-transparent" />
      </div>

      {}
      <div className="absolute top-[45%] right-[15%] z-0 hidden md:block lg:right-[25%]">
        <div className="relative flex items-center justify-center">
          <span className="absolute inline-flex size-12 animate-ping rounded-full bg-primary opacity-30"></span>
          <span className="absolute inline-flex size-6 animate-ping rounded-full bg-primary opacity-50 animation-delay-150"></span>
          <span className="relative inline-flex size-4 rounded-full bg-primary shadow-[0_0_20px_rgba(245,158,11,0.9)]"></span>
          
          {}
          <div className="absolute top-6 flex flex-col items-center whitespace-nowrap">
            <MapPin className="size-4 text-primary mb-1" />
            <span className="text-xs font-mono font-bold tracking-widest text-primary-foreground bg-primary/95 px-2 py-0.5 rounded-sm backdrop-blur-md">
              AGT OPERATIONS HUB
            </span>
          </div>
        </div>
      </div>

      <div className="container relative z-10 mx-auto px-6">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-2">
          {}
          <div className="flex items-center">
            <Card className="w-full max-w-xl border-border/40 bg-card/60 shadow-2xl backdrop-blur-xl rounded-sm">
              <CardHeader className="pb-8">
                <div className="mb-4 inline-flex w-fit items-center rounded-sm border border-primary/40 bg-primary/10 px-3 py-1 text-xs font-mono font-semibold uppercase tracking-wider text-primary">
                  <MapPin className="mr-2 size-4" />
                  Global Site Presence
                </div>
                <CardTitle className="text-4xl font-extrabold tracking-tighter lg:text-5xl font-sans">
                  Integrated Support Network
                </CardTitle>
                <CardDescription className="mt-4 text-base text-muted-foreground font-sans">
                  AGT Engineering and Consulting operates at the intersection of geotechnical precision and environmental stewardship. We provide on-site expertise where it matters most, ensuring structural integrity and compliance across international tailings facilities.
                </CardDescription>
              </CardHeader>
              <CardContent className="grid gap-6">
                {advantages.map((adv, i) => <div data-index={i} key={i} className="flex items-start gap-4">
                    <div className="mt-1 flex shrink-0 items-center justify-center rounded-sm bg-accent/20 p-2 border border-primary/20">
                      {adv.icon}
                    </div>
                    <div>
                      <h4 className="font-bold text-foreground tracking-tight font-sans">
                        {adv.title}
                      </h4>
                      <p className="mt-1 text-sm text-muted-foreground font-sans">
                        {adv.description}
                      </p>
                    </div>
                  </div>)}
              </CardContent>
              <CardFooter className="pt-8">
                <Button asChild size="lg" className="w-full sm:w-auto bg-primary text-primary-foreground hover:bg-primary/90 font-bold uppercase tracking-widest rounded-sm">
                  <Link to="/ServicesPage">Explore Our Services</Link>
                </Button>
              </CardFooter>
            </Card>
          </div>
          
          {}
          <div className="flex items-center justify-center md:hidden">
             <div className="relative flex flex-col items-center justify-center rounded-full bg-accent/10 p-12 backdrop-blur-md border border-border/30">
                <span className="absolute inline-flex size-24 animate-ping rounded-full bg-primary opacity-20"></span>
                <span className="relative inline-flex size-6 rounded-full bg-primary shadow-[0_0_15px_rgba(245,158,11,0.8)]"></span>
                <span className="mt-4 text-xs font-mono font-bold tracking-widest text-primary uppercase">
                  Active Site Support
                </span>
             </div>
          </div>
        </div>
      </div>
    </section>;
}